/*
  UTM -> Cart Attributes capture (v2)
  --------------------------------------
  Reads UTM parameters from the landing URL, stores them (first-touch,
  persists across the browser via localStorage), and writes them onto
  the Shopify cart as attributes once the cart actually has items.
  These attributes persist onto the order, where Shopify Flow reads
  them to tag the order.

  v2 changes vs the original:
  - Only calls /cart/update.js when the cart has line items (avoids
    firing on every page load for nothing)
  - Detects AJAX add-to-cart (theme cart drawers) via a form-submit
    listener AND a fetch() override, then polls until the item lands
  - Dedup guard so identical attributes aren't re-sent repeatedly
  - Storage is still first-touch localStorage (persists across days/
    sessions) -- unlike sessionStorage, which would only attribute
    orders placed in the same browser session as the ad click
*/
(function () {
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var PREFIX = 'ptz_';               // storage prefix to avoid clashing with other scripts
  var LAST_SENT_KEY = PREFIX + 'last_sent';
  var isUpdatingCart = false;        // guard against parallel /cart/update.js calls

  // 1. Read UTMs from the current URL
  var params = new URLSearchParams(window.location.search);

  // 2. Store first-touch: only write a key if we haven't captured it before.
  //    For LAST-touch instead, remove the `!localStorage.getItem(...)` check
  //    so each new visit overwrites the stored value.
  UTM_KEYS.forEach(function (key) {
    var value = params.get(key);
    if (value && !localStorage.getItem(PREFIX + key)) {
      localStorage.setItem(PREFIX + key, value);
    }
  });

  // 3. Build an attributes object from whatever we currently have stored
  function getStoredAttributes() {
    var attributes = {};
    var hasData = false;
    UTM_KEYS.forEach(function (key) {
      var stored = localStorage.getItem(PREFIX + key);
      if (stored) {
        attributes[key] = stored;
        hasData = true;
      }
    });
    return hasData ? attributes : null;
  }

  // 4. Write to the cart -- but only if the cart actually has items, and
  //    only if the attributes have changed since we last sent them.
  function updateCartAttributes() {
    if (isUpdatingCart) return;

    var attributes = getStoredAttributes();
    if (!attributes) return;

    var serialized = JSON.stringify(attributes);
    if (sessionStorage.getItem(LAST_SENT_KEY) === serialized) return;

    isUpdatingCart = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).then(function () {
          sessionStorage.setItem(LAST_SENT_KEY, serialized);
        });
      })
      .catch(function () { /* fail silently, never block the page */ })
      .finally(function () { isUpdatingCart = false; });
  }

  // 5. After an add-to-cart action, the item may take a moment to land --
  //    poll a few times before giving up.
  function pollAndUpdateCart(attemptsLeft) {
    if (attemptsLeft <= 0) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.items && cart.items.length) {
          updateCartAttributes();
        } else {
          setTimeout(function () { pollAndUpdateCart(attemptsLeft - 1); }, 800);
        }
      })
      .catch(function () {});
  }

  // 6. Catch traditional (non-AJAX) add-to-cart form submits
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.action && e.target.action.indexOf('/cart/add') !== -1) {
      pollAndUpdateCart(5);
    }
  }, true);

  // 7. Catch AJAX add-to-cart calls (cart drawers / sliders that don't
  //    reload the page) by wrapping fetch()
  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    var result = originalFetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      result.then(function () { pollAndUpdateCart(5); }).catch(function () {});
    }
    return result;
  };

  // 8. Also run on normal page load / cart page, in case items are
  //    already in the cart from a previous action
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartAttributes);
  } else {
    updateCartAttributes();
  }
})();
